import { api } from '../../core/network/api';

/** design/gdd/energy.md REST surface — plain wrappers, same convention as insurance-api.ts. */

export interface EnergyStatus {
  energy: number;
  /** The allowance a refill restores you to. Bought energy stacks above it. */
  freeDaily: number;
  costPerGame: number;
  /** ISO timestamp of the next refill, or null when already at or above the allowance. */
  refillAt: string | null;
}

export interface EnergyBundleRow {
  id: string;
  name: string;
  energy: number;
  priceEmber: number;
}

export const getEnergy = (): Promise<EnergyStatus> => api.get('/energy');

export const getEnergyBundles = (): Promise<EnergyBundleRow[]> => api.get('/energy/bundles');

export const purchaseEnergyBundle = (bundleId: string): Promise<{ energy: number; premiumBalance: number }> =>
  api.post('/energy/bundles/purchase', { bundleId });
